import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { Customer, User } from 'oas';
import { getOpenfieldRegion } from 'shared/utils';

const GATEWAY_SERVICES = [
    { url: process.env.REACT_APP_PLANNING_API_URL, needsUserId: false },
    { url: process.env.REACT_APP_USER_CONFIG_API_URL, needsUserId: true },
    { url: process.env.REACT_APP_ATHLETE_SERVICE_API_URL, needsUserId: false },
];

function gatewayServiceFor(requestUrl = '') {
    return GATEWAY_SERVICES.find((service) => service.url && requestUrl.startsWith(service.url));
}

export function applyDevIdentityHeaders(instance: AxiosInstance, user?: User, customer?: Customer): void {
    const region = getOpenfieldRegion(customer?.aws_region ?? '');

    instance.interceptors.request.use(function addIdentityHeaders(config: AxiosRequestConfig) {
        const service = gatewayServiceFor(config.url);

        if (!user || !region || !service) {
            return config;
        }

        config.headers = {
            ...config.headers,
            'X-Customer-ID': String(user.customer_id),
            'X-Customer-Region': region,
            ...(service.needsUserId ? { 'X-User-ID': user.id } : {}),
        };

        return config;
    });
}
